import { Petsitter, PetsitterStored } from '@/dataV3/PetSitter/Petsitter'
import { StoreActionMap } from '@/store/types'

export interface PetsitterUserReducer {
  currentPetsitter: Petsitter | null | PetsitterStored
  error: string | null
  isLoading: boolean
}

export const initialPetsitterUserReducerState: PetsitterUserReducer = {
  currentPetsitter: null,
  error: null,
  isLoading: false,
}

export enum PetsitterUserTypes {
  Restore = 'PetsitterUser/RESTORE',
  SetError = 'PetsitterUser/SET_ERROR',
  UpdatePetsitter = 'PetsitterUser/UPDATE_PETSITTER',
  Reset = 'PetsitterUser/RESET',
  SetLoading = 'PetsitterUser/SET_LOADING',
  Clean = 'PetsitterUser/CLEAN',
}

type PetsitterUserPayload = {
  [PetsitterUserTypes.Restore]: PetsitterUserReducer
  [PetsitterUserTypes.SetError]: string | null
  [PetsitterUserTypes.UpdatePetsitter]: Petsitter | null
  [PetsitterUserTypes.Reset]: null
  [PetsitterUserTypes.SetLoading]: boolean
  [PetsitterUserTypes.Clean]: null
}

export type PetsitterUserActions = StoreActionMap<PetsitterUserPayload>[keyof StoreActionMap<PetsitterUserPayload>]

const petsitterUserReducer = (state: PetsitterUserReducer, action: PetsitterUserActions): PetsitterUserReducer => {
  switch (action.type) {
    case PetsitterUserTypes.Restore:
      return {
        ...action.payload,
      }
    case PetsitterUserTypes.SetError:
      return {
        ...state,
        error: action.payload,
      }
    case PetsitterUserTypes.UpdatePetsitter:
      return {
        ...state,
        currentPetsitter: action.payload,
        error: null,
      }
    case PetsitterUserTypes.Reset:
      return initialPetsitterUserReducerState
    case PetsitterUserTypes.SetLoading:
      return {
        ...state,
        isLoading: action.payload,
        error: null,
      }
    case PetsitterUserTypes.Clean:
      return initialPetsitterUserReducerState
    default:
      return state
  }
}

export default petsitterUserReducer
